import { Component, OnInit } from '@angular/core';
import { Tab } from '../tabs/tabs.component';
import { Project} from '../../types/project';
import { projects } from '../../data/projects';

interface GalleryTab extends Tab {
  filter: string
}

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.less']
})
export class GalleryComponent implements OnInit {
  tabs:Array<GalleryTab> = [
    {
      name: "All",
      filter: ""
    },
    {
      name: "Professional",
      filter: "professional"
    },
    {
      name: "Personal",
      filter: "personal"
    }
  ]
  tabFilter: string
  projects: Project[]
  filteredProjects: Project[]

  onTabSelected(tab:GalleryTab) {
    this.tabFilter = tab.filter;
    this.applyFilters();
  }

  applyFilters() {
    this.filteredProjects = this.projects;
    if (this.tabFilter) {
      this.filteredProjects = this.filteredProjects.filter( (project: Project) => project.category === this.tabFilter )
    }
  }

  openURL(url:string) {
    console.log(url);
    window.location.href = url;
  }



  constructor() { }

  ngOnInit() {
    this.projects = projects;
    this.filteredProjects = projects; 
  }

}
